module.exports = __webpack_public_path__ + "img/mobile-3.dace74c5.png";